import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AiKnowledgeService } from '../ai-knowledge.service';
import { AppsForKnowledgeSourceComponent } from '../apps-for-knowledge-source/apps-for-knowledge-source.component';
import { AiKnowledgeI18nModule } from '../assets/i18n/ai-knowledge-i18n.module';

export interface Data {
  businessProfileUrl?: string;
  readOnly?: boolean;
}

@Component({
  selector: 'ai-knowledge-learn-more-business-profile',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    TranslateModule,
    AiKnowledgeI18nModule,
    AppsForKnowledgeSourceComponent,
  ],
  providers: [AiKnowledgeService],
  templateUrl: './learn-more-business-profile.component.html',
  styleUrls: ['./learn-more-business-profile.component.scss'],
})
export class LearnMoreBusinessProfileComponent {
  private readonly knowledgeService = inject(AiKnowledgeService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: Data) {}

  businessProfileUrl(): string {
    return this.knowledgeService.buildBusinessProfileUrl();
  }

  knowledgeSourceId(): string {
    return this.knowledgeService.buildBusinessProfileKnowledgeSourceId();
  }
}
